import * as colors from '../../common/colors';

export default {
  root: {
    '&.Mui-selected': {
      backgroundColor: colors.grey[300],
    },
    '&.Mui-selected:hover': {
      backgroundColor: colors.grey[400],
    },
  },
  button: {
    '&:hover': {
      backgroundColor: colors.grey[100],
    },
    '&.Mui-focusVisible': {
      backgroundColor: colors.grey[200],
    },
  },
};
